import { PdfQuoteType } from '../enums/pdf-quote-type.enum';

export class PdfQuoteTypeHelper {
  public static buildPdfMergeNotificationCardMessage(length: number, pdfDocumentType: PdfQuoteType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfQuoteType.Quote) {
      msg = {
        msgPlural: `PDF de ${length} devis`,
        msgSingular: `PDF de ${length} devis`,
      };
    }
    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static buildPdfMergeNotifyMessage(length: number, pdfDocumentType: PdfQuoteType): string | undefined {
    let msg: { msgPlural: string | undefined; msgSingular: string | undefined } = { msgPlural: undefined, msgSingular: undefined };

    if (pdfDocumentType === PdfQuoteType.Quote) {
      msg = {
        msgPlural: `PDF multiple de ${length} devis en cours de génération`,
        msgSingular: `PDF multiple de ${length} devis en cours de génération`,
      };
    }

    const message = length > 1 ? msg.msgPlural : msg.msgSingular;
    return message;
  }

  public static translateEnum(enumValue: PdfQuoteType, pluralFlag = false): string | undefined {
    if (enumValue === PdfQuoteType.Quote) {
      return pluralFlag ? 'Devis' : 'Devis';
    }
    return undefined;
  }
}
